module.exports = __webpack_public_path__ + "img/Close - Gray - Selected.98b4c309.png";